import classNames from 'classnames/bind';
import styles from './Student.module.css';

import {
  useGetSignupStudentFormQuery,
  useSubmitSignUpStudentMutation,
} from '../../../../services/api';

import SignUpForm from '../SignUpForm';

export default function Student() {
  const cx = classNames.bind(styles);
  const { data, isLoading } = useGetSignupStudentFormQuery();
  const [submit] = useSubmitSignUpStudentMutation();

  if (isLoading || !data) return null;

  return (
    <>
      <SignUpForm form={data} submit={submit} alias={data.alias} />
    </>
  );
}
